import type { BookingDetailsPriceFilters } from '@/scopes/account/booking-details/infrastructure/parser/bookingDetailsPriceFiltersParser'
import { createBookingDetailsPriceFiltersParser } from '@/scopes/account/booking-details/infrastructure/parser/bookingDetailsPriceFiltersParser'
import { createQueryStringSerializer } from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'

export function buildRebookingSearchUrl(
  searchUrl: string,
  filters: BookingDetailsPriceFilters,
  today: Date = new Date(),
): string {
  const queryStringSerializer = createQueryStringSerializer({
    parser: createBookingDetailsPriceFiltersParser({ today }),
  })

  return `${searchUrl}?${queryStringSerializer.serialize(filters)}`
}
